<template>
  <div class="range-selector-buttons">
    <template v-if="!dropdown">
      <v-tooltip bottom v-for="(item, index) in ranges" :key="item.index">
        <template #activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            :dark="value===index"
            :disabled="item.disabled"
            :outlined="value!==index"
            :style="'border: 1px solid ' + $finColors.accentGray1"
            class="pa-1"
            color="#fff"
            elevation="0"
            @click="selectedRange = item">
            {{ item.text }}
          </v-btn>
        </template>
        <span>{{ item.textDropDown || item.text }}</span>
      </v-tooltip>
    </template>
    <template v-else>
      <v-select v-model="selectedRange"
                :items="ranges"
                item-text="textDropDown"
                item-disabled="disabled"
                return-object
                :hide-details="hideDetails"
                v-bind="dropDownProps"
      />
    </template>
  </div>
</template>

<script>

export default {
  name: 'finRangeSelector',
  components: {},
  props: {
    value: {
      type: Number
    },
    ranges: {
      type: Array,
    },
    dropdown: {
      type: [Boolean, Object],
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dropDownProps() {
      if (!this.dropdown) return null
      const props = (typeof this.dropdown === 'object') ? this.dropdown : {}
      const result = {
        outlined: true,
        ...props
      }
      return result
    },
    selectRanges() {
      return this.ranges.map((r, index) => ({...r, index}))
    },
    selectedRange: {
      get() {
        return this.ranges[this.value]
      },
      set(val) {
        const index = this.ranges.indexOf(val)
        this.$emit('input', index)
      }
    }
  },
}
</script>

<style lang="scss" scoped>

.range-selector-buttons {
  .v-btn {
    background-color: #fff;
  }
}

</style>
